import { findKey } from 'lodash';

import {
  CHANNEL_TYPE_ENUM,
  INFERRED_TYPE_ENUM,
} from 'constants/chart-channels';
// TODO once client side limiting is removed via CHARTS-1227 epic, this selector and its usage should be removed
export default function isLimitingOnClientSelector(channels) {
  const channelKey = findKey(channels, {
    channelType: CHANNEL_TYPE_ENUM.CATEGORY,
    inferredType: INFERRED_TYPE_ENUM.STRING,
    isLimiting: true,
  });

  return channels[channelKey] !== undefined;
}

export { isLimitingOnClientSelector };
